import React from 'react';
import { toast } from 'sonner';
import { TypographyH2, TypographyH4 } from '@/Components/shadcn';
import { Spinner } from '@/Components/shadcn/spinner';
import { useNotificationContext } from '@/Context/NotificationContext';
import UIStrings from '@/Utils/UIStrings';
import LabeledSwitch from './LabeledSwitch';
import { useAccountSettings, usePatchNotificationsSettings } from '@/api/useAccountSettings';

function AccountSettingsNotifications(): React.JSX.Element {
    const { showSuccessToaster, showFailToaster } = useNotificationContext();
    const { data, isLoading } = useAccountSettings();
    const { sendNotificationsOnAssessmentComplete } = data.notifications;
    const { isMutating, trigger } = usePatchNotificationsSettings();

    const switchChangeHandler = async (checked: boolean) => {
        try {
            toast.dismiss();
            await trigger({ propertyName: 'sendNotificationsOnAssessmentComplete', value: checked });
            showSuccessToaster(UIStrings.NotificationsSettingsHasBeenUpdatedSuccessfully);
        } catch {
            showFailToaster();
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <TypographyH2>{UIStrings.AssessmentNotifications}</TypographyH2>
            <div className="flex flex-col gap-4">
                <TypographyH4 className="font-medium">{`${UIStrings.EmailMe}:`}</TypographyH4>
                {isLoading ? (
                    <Spinner />
                ) : (
                    <LabeledSwitch
                        disabled={isMutating}
                        label={UIStrings.WhenApplicantSubmitsAssessment}
                        onCheckedChange={switchChangeHandler}
                        checked={sendNotificationsOnAssessmentComplete}
                    />
                )}
            </div>
        </div>
    );
}

export default AccountSettingsNotifications;
